import { CommonModule } from '@angular/common';
import { Component, Inject, ViewChild } from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';
import {
  MatDatepicker,
  MatDatepickerModule
} from '@angular/material/datepicker';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
  MatDialogRef
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { I18NextModule } from 'angular-i18next';
import i18next from 'i18next';
import { OrderService } from 'src/app/core/services/order.service';
import { FeedbackModalComponent } from 'src/app/shared/components/feedback-modal/feedback-modal.component';
import { ApproversComponent } from '../../shared/components/approvers/approvers.component';
import { AuthorizerUsers } from 'src/app/shared/model/user.model';

@Component({
  standalone: true,
  selector: 'app-modal-extend-transfer',
  templateUrl: './modal-extend-transfer.component.html',
  styleUrls: ['./modal-extend-transfer.component.scss'],
  imports: [
    CommonModule,
    I18NextModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    ApproversComponent
  ]
})
export class ModalExtendTransferComponent {
  minDate: string;
  today: string;
  form: FormGroup;
  controller: AuthorizerUsers = {
    id: '',
    fullName: ''
  };
  loading = false;
  @ViewChild('picker') picker!: MatDatepicker<any>;

  constructor(
    public dialogRef: MatDialogRef<ModalExtendTransferComponent>,
    private orderService: OrderService,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    const todayDate = new Date();
    this.today = todayDate.toISOString().split('T')[0];
    if (new Date(this.data.returnDate) > new Date(this.today)) {
      this.minDate = this.data.returnDate;
    } else {
      this.minDate = this.today;
    }
    this.form = new FormGroup({
      extendDate: new FormControl('', Validators.required)
    });

    this.form.get('extendDate')?.setValue(this.data.returnDate);
  }

  close() {
    this.picker['_destroyOverlay']();
  }

  onSelectionAuthorizers(event: {
    controller: AuthorizerUsers;
    authorizer: AuthorizerUsers;
  }) {
    this.controller = event.controller;
  }

  formatDateWithoutTimezone(date: Date): string {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Meses de 0-11, por eso sumamos 1
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  submitRequest() {
    this.loading = true;
    const date = this.form.value.extendDate;
    const formattedDate = this.formatDateWithoutTimezone(new Date(date));
    const comments = '';
    const controllerId = this.controller?.id;
    const vinList = [this.data.vin];

    this.orderService
      .sendTransfers(
        vinList,
        this.data.deliveryDate,
        formattedDate,
        controllerId,
        comments
      )
      .subscribe({
        next: () => {
          this.loading = false;
          this.dialog.open(FeedbackModalComponent, {
            width: '400px',
            data: {
              text: i18next.t('transferExtended'),
              close: true,
              theme: 'dark'
            }
          });
          this.dialogRef.close();
        },
        error: () => {
          this.loading = false;
          this.dialog.open(FeedbackModalComponent, {
            width: '400px',
            data: {
              text: i18next.t('errorTransferExtended'),
              close: true,
              theme: 'dark'
            }
          });
        },
        complete: () => {
          this.loading = false;
          console.log('Fetch complete');
        }
      });
  }
}
